module.exports = __webpack_public_path__ + "img/Flag_of_Kazakhstan.0fe9097b.svg";